import { render, staticRenderFns } from "./SlaDistributionTable.vue?vue&type=template&id=286891b0&scoped=true&"
import script from "./SlaDistributionTable.vue?vue&type=script&lang=js&"
export * from "./SlaDistributionTable.vue?vue&type=script&lang=js&"
import style0 from "./SlaDistributionTable.vue?vue&type=style&index=0&id=286891b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286891b0",
  null
  
)

export default component.exports